var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"task-color",on:{"click":_vm.onClickColor}},[_c('div',{staticClass:"task-color__itself --bg-accent",class:_vm.item.color})])
}
var staticRenderFns = []

export { render, staticRenderFns }